import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import axios from 'services/axios';
import { PROFILE } from 'services/consts';

import AppLogger from './AppLogger';

const FreshChatInitializer = () => {
	const user = useSelector((state) => state.user);
	const onboarding = useSelector((state) => state.instruction);
	const localization = useSelector((state) => state.layout.localization);

	useEffect(() => {
		const freshChat = window.fcWidget;

		if (user?.initialized && !user?.isSupportUser) {
			AppLogger.log('freshchat init');
			freshChat?.init({
				siteId: import.meta.env.VITE_API_URL,
				token: import.meta.env.VITE_FRESHCHAT_API_KEY,
				host: 'https://tryoto-help.freshchat.com',
				widgetUuid: '416cde09-0f26-4233-afdf-78edbf8e3e96',
				locale: localization.systemCode.split('_').shift(),
				config: {
					headerProperty: {
						direction: localization.dir === 'rtl' ? 'ltr' : 'rtl',
						hideChatButton: true
					}
				},
				externalId: user?.ID,
				restoreId: user?.chatRestoreId ? user?.chatRestoreId : null
			});

			freshChat?.on('user:created', async (resp) => {
				const status = resp && resp.status;
				const freshchatData = resp && resp.data;
				if (status === 200) {
					if (
						freshchatData.restoreId &&
						freshchatData.restoreId !== user.chatRestoreId &&
						user.ID === Number(freshchatData.externalId)
					) {
						await axios
							.post(PROFILE.UPDATE_CHAT_RESTORE_ID, { chatRestoreId: freshchatData.restoreId })
							.then((response) => {
								if (response.status === 200) {
									// do nothing
								} else {
									AppLogger.error(response);
								}
							})
							.catch((error) => {
								AppLogger.error(error);
							});
					}
				}
			});

			freshChat?.on('csat:received', function () {
				window.activeChatAgent = false;
			});

			freshChat?.user?.setProperties({
				/* eslint-disable camelcase */
				firstName: user.fullName,
				phone: user.phone,
				email: user.email,
				cf_ClientStatus: user.clientStatus,
				cf_companyName: user.companyName,
				cf_plan: user.planName,
				cf_credit: user.remainingAmount,
				cf_userType: user.userType,
				cf_cohortAgg: user.generalSettings.cohortAgg ?? null,
				cf_cohortIntg: user.generalSettings.cohortIntg ?? null,
				country: user.localization?.countryISO2,
				locale: user.locale.split('_').shift(),
				avgShipmentPerMonth: onboarding?.averageShipmentPerMonth || ''
				/* eslint-enable camelcase */
			});
		}

		return () => {
			if (freshChat?.isInitialized()) {
				freshChat?.user?.clear().then(
					() => {
						AppLogger.log('Freshchat User Cleared!');
					},
					() => {
						AppLogger.log('Freshchat User Not Cleared!');
					}
				);
				freshChat.destroy();
			}
		};
	}, [user?.initialized, localization, user?.isSupportUser]);
};

export default FreshChatInitializer;
